import { useState } from "react";
import { DcLogo } from "../../assets/images";
import { useEffect } from "react";
import Container from "../../components/element/container";
import Col from "../../components/element/col";
import ImageComponent from "../../components/element/image";

export default function Preloader() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [removePreload, setRemovePreload] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, [isLoaded]);

  useEffect(() => {
    document.fonts.ready.then(() => {
      checkIfLoaded();
    });

    const image = new Image();
    image.src = DcLogo;
    image.onload = () => checkIfLoaded();

    function checkIfLoaded() {
      if (image.complete && document.fonts.ready) {
        setIsLoaded(true);

        setTimeout(() => {
          setRemovePreload(true);
        }, 2000);
      }
    }
  }, []);

  if (!removePreload) {
    return (
      <Container className="preloader">
        <Col className="_col gradient-background" />
        <ImageComponent src={DcLogo} loading="eager" className="_img" />
      </Container>
    );
  }
}
